"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SectionDayViewModel = void 0;
const ko = __importStar(require("knockout"));
class SectionDayViewModel {
    constructor(calVModel, configuration, stringsProvider) {
        this.hasPreviousWeeks = () => {
            return ko.computed(() => {
                var visibleWeekStartIndex = this.calVModel.visibleWeekStartIndex();
                var enabledWeekStartIndex = this.calVModel.enabledWeekStartIndex();
                return (visibleWeekStartIndex > enabledWeekStartIndex);
            }, this);
        };
        this.showPreviousWeeks = () => {
            if (this.isPrevWeeksAvailable()) {
                const enabledWeekStartIndex = this.calVModel.enabledWeekStartIndex();
                let weekStartIndex = this.calVModel.visibleWeekStartIndex() - this.numOfWeeksToShow;
                // do nothing is it's first visible week window
                if (enabledWeekStartIndex > weekStartIndex) {
                    weekStartIndex = enabledWeekStartIndex;
                }
                this.calVModel.visibleWeekStartIndex(weekStartIndex);
                const weekVModel = this.calVModel.weeks()[weekStartIndex];
                this.calVModel.calendarEvents.previousDaysClicked({
                    'dateId': weekVModel.days()[0].dateId,
                    'experience': 'weekly',
                    'startIndex': weekStartIndex,
                    'endIndex': weekStartIndex + this.numOfWeeksToShow - 1,
                    'direction': 'previous'
                });
            }
        };
        this.hasNextWeeks = () => {
            return ko.computed(() => {
                var weekStartIndex = this.calVModel.visibleWeekStartIndex() + this.numOfWeeksToShow;
                var maxWeekIndex = this.calVModel.enabledWeekEndIndex();
                return (weekStartIndex <= maxWeekIndex && maxWeekIndex >= 0);
            }, this);
        };
        this.showNextWeeks = () => {
            if (this.isNextWeeksAvailable()) {
                let weekStartIndex = this.calVModel.visibleWeekStartIndex() + this.numOfWeeksToShow;
                const maxWeekIndex = this.calVModel.enabledWeekEndIndex();
                const weekEndIndex = weekStartIndex + this.numOfWeeksToShow - 1;
                if (weekEndIndex > maxWeekIndex) {
                    weekStartIndex = weekStartIndex - (weekEndIndex - maxWeekIndex);
                }
                this.calVModel.visibleWeekStartIndex(weekStartIndex);
                const weekVModel = this.calVModel.weeks()[weekStartIndex];
                this.calVModel.calendarEvents.nextDaysClicked({
                    'dateId': weekVModel.days()[0].dateId,
                    'experience': 'weekly',
                    'startIndex': weekStartIndex,
                    'endIndex': weekStartIndex + this.numOfWeeksToShow - 1,
                    'direction': 'next'
                });
            }
        };
        this.isNextWeeksAvailable = ko.observable(false).extend({ deferred: true });
        this.isPrevWeeksAvailable = ko.observable(false).extend({ deferred: true });
        this.renderedWeeks = ko.observable([]);
        this.numOfWeeksToShow = configuration.numOfWeeksToShow;
        this.calVModel = calVModel;
        this.stringsProvider = stringsProvider;
    }
    getWeeks() {
        return ko.computed(function () {
            let visibleWeekStartIndex = this.calVModel.visibleWeekStartIndex();
            let visibleWeekEndIndex = visibleWeekStartIndex + this.numOfWeeksToShow;
            // To handle special cases where inventory is only present for one week at the start of the month.
            // We are ensuring that if the enabled week is the first week of the month, then along with it
            // next week will be show and no attempt will be made to retrieve the previous week. 
            if (visibleWeekStartIndex !== 0) {
                if (this.calVModel.enabledWeekEndIndex() < visibleWeekEndIndex - 1) {
                    // visibleWeekEndIndex value shouldn't be less than numOfWeeksToShow otherwise visibleWeekStartIndex will go out of bound.
                    visibleWeekEndIndex = Math.max(this.numOfWeeksToShow, this.calVModel.enabledWeekEndIndex() + 1);
                }
                if (visibleWeekEndIndex - visibleWeekStartIndex !== this.numOfWeeksToShow) {
                    visibleWeekStartIndex = visibleWeekEndIndex - this.numOfWeeksToShow;
                }
            }
            this.isNextWeeksAvailable = this.hasNextWeeks();
            this.isPrevWeeksAvailable = this.hasPreviousWeeks();
            if (this.calVModel.days().length >= visibleWeekEndIndex) {
                const weeks = this.calVModel.weeks().slice(visibleWeekStartIndex, visibleWeekEndIndex);
                this.renderedWeeks(weeks);
                return weeks;
            }
            return [];
        }, this);
    }
    getMonths() {
        return ko.computed(function () {
            return this.calVModel.months();
        }, this);
    }
    getMonthNameHeader() {
        return ko.computed(() => {
            const weekStartIndex = this.calVModel.visibleWeekStartIndex();
            const selectedDayIndex = this.calVModel.selectedDayIndex();
            const weeks = this.calVModel.weeks();
            const days = this.calVModel.days();
            const selectedDay = days[selectedDayIndex];
            let weekFirstDay;
            if (weeks[weekStartIndex]) {
                weekFirstDay = weeks[weekStartIndex].days()[0];
            }
            if (!weekFirstDay || !selectedDay) {
                return '';
            }
            // if selected days are in current week window
            if ((selectedDay.weekIndex >= weekStartIndex) &&
                (selectedDay.weekIndex <= (weekStartIndex + this.numOfWeeksToShow - 1))) {
                return this.stringsProvider.getString('g:full-mname:' + (selectedDay.monthOfYear - 1));
            }
            return this.stringsProvider.getString('g:full-mname:' + (weekFirstDay.monthOfYear - 1));
        }, this);
    }
    getMonthlyViewHeader() {
        return this.stringsProvider.getString('g:datesheader');
    }
    ;
    getShowMoreDaysLabel() {
        return this.stringsProvider.getString('g:show-more-days');
    }
    ;
    getNextDaysLabel() {
        return this.stringsProvider.getString('g:nextdays-label');
    }
    getPreviousDaysLabel() {
        return this.stringsProvider.getString('g:prevdays-label');
    }
}
exports.SectionDayViewModel = SectionDayViewModel;
